export class PmSiteRequest {
  domain: string;
  iabCat: string;
  monthlyImpressions: number;
  identifier: string;
}
